import Navbar from "../../Components/Navbar";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Select, Button, message, Table } from "antd";
import axios from "axios";
import { Base_Uri } from "../../Constant/BaseUri";

const { Option } = Select;

const MainSetting = () => {
  const [allowedCountries, setAllowedCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [userCountry, setUserCountry] = useState("");

  useEffect(() => {
    fetchCountries();
    fetchUserCountry();
    fetchAllCountries();
  }, []);
  const allowedCountryCodes = new Set(allowedCountries.map((i) => i.code));

  // Fetch allowed countries from server
  const fetchCountries = () => {
    axios
      .get(`${Base_Uri}countries`)
      .then((res) => setAllowedCountries(res.data))
      .catch((err) => console.error("Error fetching countries:", err));
  };
  const fetchAllCountries = () => {
    axios
      .get(`https://restcountries.com/v3.1/all`)
      .then((res) => setAllCountries(res.data))
      .catch((err) => console.error("Error fetching countries:", err));
  };

  // Get user country by IP
  const fetchUserCountry = () => {
    axios
      .get(`https://geolocation-db.com/json/`)
      .then((res) => setUserCountry(res.data.country_code))
      .catch((err) => console.error("Error detecting country:", err));
  };

  // Handle selection
  const handleChange = (value, k) => {
    //console.log(k);
    setSelectedCountries((prev) => [
      ...prev,
      ...k.map((e) => ({ code: e.value, name: e.key })),
    ]);
  };

  // Submit selected countries to server
  const handleSubmit = () => {
    //console.log(selectedCountries);
    axios
      .post(`${Base_Uri}save-countries`, { selectedCountries })
      .then(() => {
        message.success("Countries saved successfully!");
        setSelectedCountries([]);
        fetchCountries(); // Refresh list
      })
      .catch(() => message.error("Failed to save countries"));
  };

  // Delete selected countries from server
  const handleDelete = (code) => {
    axios
      .delete(`${Base_Uri}delete-countries`, { data: { countryCodes: [code] } })
      .then(() => {
        message.success("Countries deleted successfully!");
        fetchCountries(); // Refresh list
      })
      .catch(() => message.error("Failed to delete countries"));
  };
  const columns = [
    {
      title: "Country Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Country Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Button danger onClick={() => handleDelete(record.code)}>
          Delete
        </Button>
      ),
    },
  ];
  return (
    <Box>
      <Navbar />
      <div style={{ width: "400px", margin: "50px auto" }}>
        <h2>Current Country : {userCountry}</h2>

        <Select
          mode="multiple"
          showSearch
          style={{ width: "100%" }}
          placeholder="Select countries"
          onChange={handleChange}
          value={selectedCountries.map((e) => e.code)}
        >
          {allCountries
            .filter((e) => !allowedCountryCodes.has(e.cca2))
            .map((country) => (
              <Option key={country.name.common} value={country.cca2}>
                <img
                  src={country.flags.png}
                  style={{ width: 20, height: 15 }}
                  alt=""
                />{" "}
                {country.name.common} {country.cca2}
              </Option>
            ))}
        </Select>

        <Button
          type="primary"
          style={{ marginTop: "20px", width: "100%" }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
        <Table dataSource={allowedCountries} columns={columns} rowKey="code" />

        {/* <Button danger style={{ marginTop: "10px", width: "100%" }} onClick={handleDelete}>
        Delete Selected
      </Button> */}
      </div>
    </Box>
  );
};

export default MainSetting;
